import React from "react";
import { usageSteps } from "../data/landing";
export function HowItWorksSection() {
  return <section className="bg-paper" data-id="element-106" data-mp="ftha9wk990wn">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-107" data-mp="fsfvpi415wa6">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-108" data-mp="uidhjrehm9w7">
          Comment partager ces moments de foi avec vos enfants ?
        </h2>

        <div className="relative mt-12 md:mt-16" data-id="element-109" data-mp="1sentipclol7">
        <div className="absolute left-[16%] right-[16%] top-7 hidden h-px bg-ink/20 md:block" aria-hidden="true" data-id="element-110" data-mp="1vald5xaab94" />
        <ol className="relative grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-111" data-mp="au4n1aph1rtj">
          {usageSteps.map((step, i) => <li key={step.title} className="relative flex gap-5 md:flex-col md:items-center md:text-center" data-id="element-112" data-mp="6r82hegdflmy" data-mpi={i}>
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-cream font-display text-2xl font-bold text-terracotta ring-1 ring-ink/15" data-id="element-113" data-mp="1m7qe51ew63hp">
                {i + 1}
              </span>
              <div data-id="element-114" data-mp="wacz5hwz4p8g">
                <h3 className="font-display text-xl font-semibold text-ink md:mt-5 md:text-2xl" data-id="element-115" data-mp="119pny87eo6do">
                  {step.title}
                </h3>
                <p className="mt-2 leading-relaxed text-ink-soft md:mx-auto md:max-w-xs" data-id="element-116" data-mp="15cmc0efpsup0">
                  {step.text}
                </p>
              </div>
            </li>)}
        </ol>
        </div>

        <p className="mt-14 text-center font-display text-xl italic text-sage-deep md:text-2xl" data-id="element-117" data-mp="dlq0bh5e4w3b">
          Quelques minutes peuvent suffire pour commencer une belle conversation.
        </p>
      </div>
    </section>;
}